module.exports = __webpack_public_path__ + "img/hzgcsmall.9fdf6c8c.png";